/**
 * Copyright 2013 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.CSSLoader = require('./loader/CSSLoader');
exports.ImageLoader = require('./loader/ImageLoader');
exports.JSBenchLoader = require('./loader/JSBenchLoader');
exports.JSLoader = require('./loader/JSLoader');
exports.TMPLLoader = require('./loader/TMPLLoader');
exports.JSMockLoader = require('./loader/JSMockLoader');
exports.JSTestLoader = require('./loader/JSTestLoader');
exports.ProjectConfigurationLoader =
  require('./loader/ProjectConfigurationLoader');
exports.ResourceLoader = require('./loader/ResourceLoader');



//////////////////
// WEBPACK FOOTER
// ./~/node-haste/lib/loaders.js
// module id = 1599
// module chunks = 0